import { workingHourConstants } from '../constant/workingHour.constants';
import { workingHour } from '../services/workingHour.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getWorklogList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        workingHour.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;                        
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
                        
                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(workLog) { 
        return { type: workingHourConstants.GET_SUCCESS, workLog }; 
    }
}

export const addWorklog = (data) => {
    const updateData = {...data};
    if(!data.is_accept) updateData.is_accept = 0;
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        workingHour.add(updateData)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;                        
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: workingHourConstants.ADD_SUCCESS, code }; 
    }
    function failure(error) {
        return { type: workingHourConstants.ADD_FAILURE, error }; 
    }
};

export const updateWorklog = (data) => {
    const updateData = {...data};
    if(!data.is_accept) updateData.is_accept = 0;
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        workingHour.update(updateData)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APIUpdatedSuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: workingHourConstants.UPDATE_SUCCESS, code }; 
    }
    function failure(error) {
        return { type: workingHourConstants.UPDATE_FAILURE, error }; 
    }
};

export const deleteWorklog = (data) => {
    const updateData = {...data};
    if(!data.is_accept) updateData.is_accept = 0;
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        workingHour.delete(updateData)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: workingHourConstants.DELETE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: workingHourConstants.DELETE_FAILURE, error }; 
    }
}

export const getApproval = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        workingHour.getApproval(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: workingHourConstants.GETAPPROVAL_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: workingHourConstants.GETAPPROVAL_FAILURE, error }; 
    }
}

export const clearSuccessCode = () => {
    return { type: workingHourConstants.CLEAR_SUCCESS_CODE}; 
}
